import { API } from '@/api';
import { parseLocaleInt, parseLocaleNumber } from '@/utils/numbers';

type NewInvestmentData = {
  companyId: number;
  investorId: number;
  date: Date;
  sharePrice: string;
  shareCount: string;
  // currency: string; // TODO
};

type UpdateInvestmentData = Omit<
  NewInvestmentData,
  'investorId' | 'companyId'
> & {
  investmentId: number;
};

export const classes = {
  wrapper: 'w-full flex items-center justify-between',
  fieldsWrapper: 'flex items-center',
  optionsWrapper: 'flex items-center justify-center grow',
  dateTime: 'ml-0 mr-2 pb-0 pt-0 w-[200px] shrink-0',
  shareCount: 'mx-2 flex-0 w-[150px]',
  priceInput: 'mx-2 flex-0 w-[175px]',
  addButton: 'ml-2 py-2',
  iconsWrapper: 'flex',
  closeIcon: 'mr-2',
  optionsIcon: 'cursor-pointer ml-2',
};

export function createInvestment({
  companyId,
  investorId,
  date,
  sharePrice,
  shareCount,
  // currency, TODO
}: NewInvestmentData) {
  return API.Investments.createNewInvestment({
    companyId,
    investorId,
    currency: 'EUR', // TODO
    date: date.toISOString(),
    price: getPrice(shareCount, sharePrice).toString(),
    shareCount: parseLocaleInt(shareCount),
  });
}

export function updateInvestment({
  investmentId,
  date,
  sharePrice,
  shareCount,
  // currency, TODO
}: UpdateInvestmentData) {
  return API.Investments.updateInvestment(investmentId, {
    date: date.toISOString(),
    price: getPrice(shareCount, sharePrice).toString(),
    shareCount: parseLocaleInt(shareCount),
  });
}

function getPrice(shareCount: string, sharePrice: string) {
  return parseLocaleInt(shareCount) * parseLocaleNumber(sharePrice);
}
